import { generateScopedActionCreator } from '@synthetica-ai/system';
const { createEffectAction } = generateScopedActionCreator('APP');
export const startApplication = createEffectAction('START_APPLICATION');
